import { createSlice } from "@reduxjs/toolkit";

/**
 * Tracks an upload whose invoice has not finished extracting. The POST returns
 * before the backend lists the invoice, so the lists poll only while a watch is
 * open and close it as soon as the new invoice shows up extracted — or after
 * `UPLOAD_WATCH_TIMEOUT_MS`, so an invoice that never appears cannot poll forever.
 *
 * `guids` are the uploaded invoices' ids, returned by the uploads. A second
 * upload while the first is still extracting adds to the set instead of
 * replacing it, and the time limit restarts from the latest upload.
 */
export const UPLOAD_WATCH_TIMEOUT_MS = 2 * 60 * 1000;
export const UPLOAD_WATCH_POLL_MS = 5000;

const uploadWatchSlice = createSlice({
  name: "uploadWatch",
  initialState: { startedAt: null, guids: [] },
  reducers: {
    startUploadWatch(state, action) {
      // Ignore a missing guid: it could never be matched, so the watch would only
      // run out its time limit.
      const guid = action.payload;
      if (!guid) return;
      state.startedAt = Date.now();
      if (!state.guids.includes(guid)) state.guids.push(guid);
    },
    endUploadWatch(state) {
      state.startedAt = null;
      state.guids = [];
    },
  },
});

export const { startUploadWatch, endUploadWatch } = uploadWatchSlice.actions;
export default uploadWatchSlice.reducer;
